<template>
	<div>
		
		<router-view />
	</div>
</template>

<script setup>

import { useStore } from 'vuex'
import cookie from "cookie.js";

const store = useStore()

if (!store.state.login.userInfo.id && cookie.get('accessToken')) {
    store.dispatch('getUserInfo')
}

</script>

<style lang="scss" scoped>

</style>
